import { Component, OnInit } from '@angular/core';
import { TeamMembersService } from '../_services/index';
import { TeamMember } from '../_models/index';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { User } from '../_models/index';
import { AlertService, UserService } from '../_services/index';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-manage-team',
  templateUrl: './manage-team.component.html',
  styleUrls: ['./manage-team.component.css']
})
export class ManageTeamComponent implements OnInit {
  results$ : Observable<TeamMember[]>;
  team_members = [];
  loading = false;
  edit = [];

  constructor(
      private teammemberService: TeamMembersService,
      private userService: UserService,
      private route: ActivatedRoute,
      private router: Router,
      private alertService: AlertService) { }

  ngOnInit() {
    this.results$ = this.teammemberService.getTeamMembers();
    this.results$.subscribe( data => {
      this.team_members = data;
      for(var i=0;i<data.length;i++)
        this.edit[i] = false;
      console.log(data);
    });
  }

  deleteMember(i){
    var m = this.team_members[i];

    this.teammemberService.delete(m.id).subscribe(
        data => {
            console.log('teammemberService.delete.done');
            this.team_members.splice(i, 1);
            this.alertService.success('Successfully deleted User', true);
        },
        error =>{
            console.log('error');
            this.alertService.error(JSON.stringify(error.error));
            this.loading = false;
        });
  }

  saveMember(i: any){
    this.edit[i] = false;
    this.loading = true;
    var u = Object.assign({}, this.team_members[i]);
    delete u.team_name;
    this.userService.update(u)
      .subscribe(
        data => {
            console.log('updated');
            this.alertService.success('Successfully Updated User', true);
        },
        error => {
            console.log('error');
            this.alertService.error(JSON.stringify(error.error));
            this.loading = false;
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/manage-team/manage-team.component.ts